// @module C3.ShoppingExtensions.InventoryList
define('C3.ClearItems.View'
, [
    'tekyard_clearitems_view.tpl',
    'C3.Utils.CartUtils'
    ]
, function (
    tekyard_clearitems_view_tpl,
    CartUtils
)
{
    'use strict';

  // @class C3.ShoppingExtensions.InventoryList.View @extends Backbone.View
  return Backbone.View.extend({

    template: tekyard_clearitems_view_tpl

  , initialize: function (options) {
      //console.log(options)
      this.options = options || {};
      this.assets = options.assets || [];
      this.template = tekyard_clearitems_view_tpl;
      this.parentView = options.parentView;
      this.itemId = options.itemId;
      this.application = options.application;
    }

  , events: {
      'click [data-action="remove-serial-item"]':'removeSerialItem'
    }

  , bindings: {
    }

  ,  removeSerialItem : function removeSerialItem (e) {
        var targetElement = $(e.currentTarget)
        ,   assetid = targetElement.attr('data-asset')

        var self = this;
        var removed = CartUtils.removeItemFromCart(
              self.application,
              self.itemId,
              { custcol_internalassettag: assetid }
          ).then(function(removed) {
            if (removed) {
              // Update child’s local assets
              self.assets = self.assets.filter(function (tag) {
                  return tag !== assetid;
              });
              self.render();

              if (self.parentView) {
                var currentSelected = self.parentView.$('.carousel-item.viewing-item').closest('li').data('asset');             
                 self.parentView.trigger('serial:removed', {
                    removed: assetid,
                    current: currentSelected
                });
              }
              if (self.parentView && self.parentView.detailView) {
                  self.parentView.detailView.refreshCartStatus().then(() => {
                      self.parentView.detailView.render();
                  });
                  //self.parentView.detailView.refreshCartStatus(); // reuse existing method
              }

          }
        }.bind(this)); 

      }
        
    //@method getContext @return C3.ShoppingExtensions.InventoryList.View.Context
  , getContext: function getContext()
    {
      var groupedAssets = [];

      if (this.assets && this.assets.length) {
        for (var i = 0; i < this.assets.length; i += 4) {
          groupedAssets.push(this.assets.slice(i, i + 4));
        }
      }

      return {
        assetTagsGrouped: groupedAssets,
        hasAssetTags: groupedAssets.length > 0
      };
    }
  });
});
